import { ProjectFilterDefault } from "@repo/api";

import { currencyFormatter } from "./currencyFormatter";

export const formatAmountRange = (
  amount: number[] | undefined,
  currency: string,
  locale: string,
  disableDecimals: boolean
) => {
  if (amount === undefined) {
    return undefined;
  }
  if (
    amount.length === 2 &&
    amount[0] === ProjectFilterDefault.amount?.[0] &&
    amount[1] === ProjectFilterDefault.amount?.[1]
  ) {
    return undefined;
  }

  return `${currencyFormatter({
    value: amount?.[0],
    currency,
    locale,
    showSign: true,
    disableDecimals,
    fractions: 0,
  })} - ${currencyFormatter({
    value: amount?.[1],
    currency,
    locale,
    showSign: true,
    disableDecimals,
    fractions: 0,
  })}`;
};
